var _rect, _rect2, _g, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromotionButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 85,
    viewBox: "0 0 82 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 85,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 1018,
    transform: "translate(-278 -741)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_431_9501)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -261,
    y: -75,
    width: 343,
    height: 160,
    rx: 12,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 47.75,
    fill: "white",
    stroke: "#F2F2F2",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 23,
    width: 141,
    height: 50,
    rx: 12,
    fill: "url(#paint0_linear_431_9501)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -260.25,
    y: -74.25,
    width: 341.5,
    height: 158.5,
    rx: 11.25,
    stroke: "#F2F2F2",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_431_9501",
    x1: 32.7378,
    y1: 7.37501,
    x2: 176.579,
    y2: 55.3204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F90870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3244E4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_431_9501"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -261,
    y: -75,
    width: 343,
    height: 160,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionButton);
export default __webpack_public_path__ + "static/media/promotion-button.530af6201bfb3323005ff918c09b37af.svg";
export { ForwardRef as ReactComponent };